// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Rendered Markdown content (GitHub Flavored Markdown look) and the page editor.
 */

.wiki-markdown h1,
.wiki-markdown h2,
.wiki-markdown h3,
.wiki-markdown h4 {
  font-weight: 600;
  line-height: 1.25;
  margin-top: 24px;
  margin-bottom: 16px;
}

.wiki-markdown h1:first-child,
.wiki-markdown h2:first-child,
.wiki-markdown h3:first-child,
.wiki-markdown h4:first-child {
  margin-top: 0;
}

.wiki-markdown h1,
.wiki-markdown h2 {
  padding-bottom: 8px;
  border-bottom: 1px solid var(--gh-border-default);
}

.wiki-markdown h1 {
  font-size: 2em;
}

.wiki-markdown h2 {
  font-size: 1.5em;
}

.wiki-markdown p {
  margin-top: 0;
  margin-bottom: 16px;
}

.wiki-markdown ul,
.wiki-markdown ol {
  padding-left: 2em;
  margin-top: 0;
  margin-bottom: 16px;
}

.wiki-markdown li + li {
  margin-top: 4px;
}

.wiki-markdown pre {
  background-color: var(--gh-canvas-subtle);
  border-radius: var(--gh-radius);
  padding: 16px;
  overflow-x: auto;
  margin-bottom: 16px;
}

.wiki-markdown code {
  background-color: rgba(175, 184, 193, 0.2);
  color: var(--gh-fg-default);
  border-radius: 6px;
  padding: 0.2em 0.4em;
  font-family: ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, monospace;
  font-size: 0.85em;
}

.wiki-markdown pre code {
  background-color: transparent;
  padding: 0;
  font-size: 100%;
}

.wiki-markdown blockquote {
  border-left: 4px solid var(--gh-border-default);
  color: var(--gh-fg-muted);
  padding-left: 1em;
  margin-left: 0;
}

.wiki-markdown hr {
  height: 0;
  margin: 24px 0;
  border: 0;
  border-top: 1px solid var(--gh-border-default);
  background-color: transparent;
}

.wiki-markdown img {
  max-width: 100%;
}

.wiki-markdown table {
  border-collapse: collapse;
  width: 100%;
  margin-bottom: 16px;
}

.wiki-markdown th,
.wiki-markdown td {
  border: 1px solid var(--gh-border-default);
  padding: 6px 13px;
}

/* Matches the specificity of the .gh-box table rules (see box.css) and wins
   via import order (markdown.css is imported after box.css) so the GFM look
   (bold header, striped rows) applies within the .gh-box wrapper. */
.wiki-markdown table thead th {
  font-weight: 600;
  color: var(--gh-fg-default);
  background-color: var(--gh-canvas-subtle);
}

.wiki-markdown table tbody tr:nth-child(2n) td {
  background-color: var(--gh-canvas-subtle);
}

/* .gh-box removes the last row's bottom border (see box.css); restore it here
   since a markdown table's last row does not sit flush against the box edge. */
.wiki-markdown table tbody tr:last-child td {
  border-bottom: 1px solid var(--gh-border-default);
}

.wiki-editor-textarea {
  font-family: ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, monospace;
  font-size: 13px;
}

.wiki-editor-preview {
  border: 1px solid var(--gh-border-default);
  border-radius: var(--gh-radius);
  padding: 16px;
  min-height: 200px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/markdown.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;;;;EAIE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;;EAEE,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,+BAA+B;EAC/B,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;EAC3B,kBAAkB;EAClB,oBAAoB;EACpB,gFAAgF;EAChF,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,+CAA+C;EAC/C,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,SAAS;EACT,8CAA8C;EAC9C,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,0CAA0C;EAC1C,iBAAiB;AACnB;;AAEA;;oEAEoE;AACpE;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;+EAC+E;AAC/E;EACE,iDAAiD;AACnD;;AAEA;EACE,gFAAgF;EAChF,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,+BAA+B;EAC/B,aAAa;EACb,iBAAiB;AACnB","sourcesContent":["/*\n * Rendered Markdown content (GitHub Flavored Markdown look) and the page editor.\n */\n\n.wiki-markdown h1,\n.wiki-markdown h2,\n.wiki-markdown h3,\n.wiki-markdown h4 {\n  font-weight: 600;\n  line-height: 1.25;\n  margin-top: 24px;\n  margin-bottom: 16px;\n}\n\n.wiki-markdown h1:first-child,\n.wiki-markdown h2:first-child,\n.wiki-markdown h3:first-child,\n.wiki-markdown h4:first-child {\n  margin-top: 0;\n}\n\n.wiki-markdown h1,\n.wiki-markdown h2 {\n  padding-bottom: 8px;\n  border-bottom: 1px solid var(--gh-border-default);\n}\n\n.wiki-markdown h1 {\n  font-size: 2em;\n}\n\n.wiki-markdown h2 {\n  font-size: 1.5em;\n}\n\n.wiki-markdown p {\n  margin-top: 0;\n  margin-bottom: 16px;\n}\n\n.wiki-markdown ul,\n.wiki-markdown ol {\n  padding-left: 2em;\n  margin-top: 0;\n  margin-bottom: 16px;\n}\n\n.wiki-markdown li + li {\n  margin-top: 4px;\n}\n\n.wiki-markdown pre {\n  background-color: var(--gh-canvas-subtle);\n  border-radius: var(--gh-radius);\n  padding: 16px;\n  overflow-x: auto;\n  margin-bottom: 16px;\n}\n\n.wiki-markdown code {\n  background-color: rgba(175, 184, 193, 0.2);\n  color: var(--gh-fg-default);\n  border-radius: 6px;\n  padding: 0.2em 0.4em;\n  font-family: ui-monospace, SFMono-Regular, \"SF Mono\", Menlo, Consolas, monospace;\n  font-size: 0.85em;\n}\n\n.wiki-markdown pre code {\n  background-color: transparent;\n  padding: 0;\n  font-size: 100%;\n}\n\n.wiki-markdown blockquote {\n  border-left: 4px solid var(--gh-border-default);\n  color: var(--gh-fg-muted);\n  padding-left: 1em;\n  margin-left: 0;\n}\n\n.wiki-markdown hr {\n  height: 0;\n  margin: 24px 0;\n  border: 0;\n  border-top: 1px solid var(--gh-border-default);\n  background-color: transparent;\n}\n\n.wiki-markdown img {\n  max-width: 100%;\n}\n\n.wiki-markdown table {\n  border-collapse: collapse;\n  width: 100%;\n  margin-bottom: 16px;\n}\n\n.wiki-markdown th,\n.wiki-markdown td {\n  border: 1px solid var(--gh-border-default);\n  padding: 6px 13px;\n}\n\n/* Matches the specificity of the .gh-box table rules (see box.css) and wins\n   via import order (markdown.css is imported after box.css) so the GFM look\n   (bold header, striped rows) applies within the .gh-box wrapper. */\n.wiki-markdown table thead th {\n  font-weight: 600;\n  color: var(--gh-fg-default);\n  background-color: var(--gh-canvas-subtle);\n}\n\n.wiki-markdown table tbody tr:nth-child(2n) td {\n  background-color: var(--gh-canvas-subtle);\n}\n\n/* .gh-box removes the last row's bottom border (see box.css); restore it here\n   since a markdown table's last row does not sit flush against the box edge. */\n.wiki-markdown table tbody tr:last-child td {\n  border-bottom: 1px solid var(--gh-border-default);\n}\n\n.wiki-editor-textarea {\n  font-family: ui-monospace, SFMono-Regular, \"SF Mono\", Menlo, Consolas, monospace;\n  font-size: 13px;\n}\n\n.wiki-editor-preview {\n  border: 1px solid var(--gh-border-default);\n  border-radius: var(--gh-radius);\n  padding: 16px;\n  min-height: 200px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
